<template>
    <!-- Kontener pojedynczego widoku filtra: ustawiamy flexowy układ w wierszu -->
    <div class="filter d-flex">
      <!-- Etykieta filtra: wyświetla przetłumaczoną nazwę (i18n) -->
      <div class="name">{{ $t(name) }}</div>
      <!-- Symbol operatora: wyświetlany tylko jeśli został przekazany jako props -->
      <span v-if="symbol">{{ symbol }}</span>
      <!-- Pole input tylko do odczytu:
           - atrybut name odpowiada kluczowi filtra w store
           - jeśli nazwa filtra to 'registration', wartość zostaje zamieniona na wielkie litery
           - pole jest zablokowane (disabled), ponieważ to tylko widok wybranej wartości
      -->
      <input
        :name="fieldName"
        :value="name === 'registration' ? value.toUpperCase() : value"
        disabled
      />
    </div>
  </template>
  
  <script>
  export default {
    // Unikalna nazwa komponentu wykorzystana przez Vue DevTools i wewnętrznie przez Vue
    name: "SingleFilterView",
    // Definicja właściwości przekazywanych z komponentu nadrzędnego:
    // - name: klucz filtra, używany również jako tłumaczenie etykiety
    // - symbol: opcjonalny symbol operatora (np. '=', '>=')
    // - fieldName: nazwa pola w store (klucz filtra)
    // - value: bieżąca wartość filtra do wyświetlenia
    props: ["name", "symbol", "fieldName", "value"],
  };
  </script>
  
  <style scoped>
  /* Styl etykiety nazwy filtra */
  .name {
    width: 100px;        /* Stała szerokość kolumny z nazwą */
    padding: 15px 0;     /* Padding góra-dół, wyrównanie w pionie */
  }
  
  /* Styl pola input wyświetlającego wartość filtra */
  input {
    width: 100px;        /* Szerokość pola */
    text-align: center;  /* Wyśrodkowanie tekstu */
    margin: 5px;         /* Margines wokół pola */
  }
  </style>